import 'react';
import { jsx } from 'react/jsx-runtime';
import { useBreakpoint } from '../../hooks/useBreakpoint.js';
import { PWAProvider } from '../../utils/pwa/context.js';
import { I18nProvider } from '../../utils/i18n/context.js';
import { LinkContext } from '../../utils/link/context.js';
import { ImageContext } from '../../utils/image/context.js';
import { ScreenSizeContext } from '../../utils/screenSize/context.js';

const DEFAULT_LOCALE = 'en-US';
const AppProvider = ({
  children,
  linkComponent,
  imageComponent,
  locale = DEFAULT_LOCALE,
  i18n
}) => {
  const breakPoint = useBreakpoint();
  return /*#__PURE__*/jsx(PWAProvider, {
    children: /*#__PURE__*/jsx(I18nProvider, {
      locale: locale,
      i18n: i18n,
      children: /*#__PURE__*/jsx(LinkContext.Provider, {
        value: linkComponent,
        children: /*#__PURE__*/jsx(ImageContext.Provider, {
          value: imageComponent,
          children: /*#__PURE__*/jsx(ScreenSizeContext.Provider, {
            value: breakPoint,
            children: children
          })
        })
      })
    })
  });
};

export { AppProvider };
